// import Image from "next/image";
import dynamic from "next/dynamic";
const Button = dynamic(() => import("@/Components/Button"), { ssr: true });
const Breadcrumb = dynamic(() => import("@/Components/Breadcrumb/Breadcrumb"), {
  ssr: true,
});

interface BannerProps {
  data?: any;
  parent?: any;
  isMobile?: any;
  breadcrumbs?: any;
}

const Banner: React.FC<BannerProps> = ({ data, breadcrumbs }) => {
  return (
    <section className="relative bg-background-dark text-white pt-[140px] xl:pt-[180px] py-[56px] xl:py-[100px]  md:pt-[154px] md:py-[80px] overflow-hidden">
      {/* Background Image */}

      {/* {isMobile &&
        <>
          <Image
            src="/images/consulting/hero-mobile.png?v=1"
            width={571}
            height={571}
            alt="banner-vector"
            className="absolute w-[571px] h-[571px] bottom-0 left-0  right-0 z-1 bg-cover bg-no-repeat bg-center  block sm:hidden"
            quality={80}
            loading="eager"
            priority
          />
          <Image
            src="/images/consulting/Mobile-Vector.png"
            width={571}
            height={571}
            alt="banner-vector"
            className="blue-shape absolute w-[571px] h-[571px] top-0 left-0 center z-1 bg-cover bg-no-repeat bg-center block sm:hidden"
            quality={100}
            loading="eager"
            priority
          />
          <Image
            src="/images/consulting/Mobile-Vector-green.png"
            width={571}
            height={571}
            alt="banner-vector"
            className="green-shape absolute w-[50%] h-[571px] bottom-0 right-0 z-1 bg-cover bg-no-repeat bg-center  block sm:hidden"
            quality={100}
            loading="eager"
            priority
          />
        </>
      }
      
      {!isMobile &&
        <>
          <Image
            src="/images/consulting/banner-top.png"
            width={571}
            height={571}
            alt="banner-vector"
            className="absolute w-[571px] h-[571px] top-[-80px] left-0 z-1 bg-cover bg-no-repeat bg-center hidden sm:block"
            quality={80}
            loading="eager"
            priority
          />
          <Image
            src="/images/consulting/lines-new.png"
            width={526}
            height={515}
            alt="banner-vector"
            className="absolute w-[526px] h-[146px] top-[auto] xl:left-[-121px] md:left-[-120px] left-[-100px] right-[-130px] xl:bottom-0 bottom-[-50px] z-1 bg-cover bg-no-repeat bg-center  hidden sm:block"
            quality={80}
            loading="eager"
            priority
          />
          <Image
            src="/images/consulting/lines-new.png"
            width={470}
            height={470}
            alt="banner-vector"
            className="absolute w-[526px] h-[146px top-[auto]  right-[-130px] md:right-[-230px] xl:right-[-153px] xl:bottom-0 md:bottom-[-48px] bottom-[-90px] z-0 bg-cover bg-no-repeat bg-center  hidden sm:block "
            quality={80}
            loading="eager"
            priority
          />
          <Image
            src="/images/consulting/banner-bottom.png"
            width={470}
            height={470}
            alt="banner-vector"
            className="absolute w-[470px] bottom-0 top-[auto] right-0 z-1 bg-cover bg-no-repeat bg-center hidden sm:block"
            quality={80}
            loading="eager"
            priority
          />
        </>
      } */}

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          {breadcrumbs?.item?.length > 0 && (
            <Breadcrumb
              items={breadcrumbs?.item ?? []}
              className2="text-subtitle-3 text-center text-gray-300"
              className=" text-gray-300 xl:mb-[48px] md:mb-[16px] mb-[16px] xl:mt-[32px]  whitespace-nowrap overflow-hidden w-[95%] text-ellipsis flex-row text-subtitle-3 md:text-subtitle-3 md:mt-[0] flex items-center justify-center text-center"
            />
          )}

          <h1 className="text-display font-extrabold text-primary-text-white uppercase max-w-[1078px] ">
            {data?.title}
          </h1>

          <p className="text-secondary-text-white text-subtitle-2 font-regular xl:max-w-[776px] max-w-[776px] sm:mt-[10px] mt-[16px]">
            {data?.description}
          </p>

          {data?.Cta?.label && data?.Cta?.href && (
            <a href={data?.Cta?.href} className="inline-block">
              <Button label={data?.Cta?.label} className="mt-[16px]" />
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default Banner;
